import { createRouter, createWebHistory } from 'vue-router'
import { applyDocumentDirForPath } from '../i18n'

const routes = [
  {
    path: '/backoffice/login',
    name: 'Login',
    component: () => import('../views/Backoffice/BackofficeLogin.vue')
  },
  {
    path: '/backoffice',
    name: 'Login',
    component: () => import('../views/Backoffice/BackofficeLogin.vue')
  },
  {
    path: '/backoffice/home',
    name: 'Home',
    component: () => import('../views/Backoffice/BackofficeHome.vue')
  },
  {
    path: '/backoffice/logout',
    name: 'Logout',
    component: () => import('../views/Backoffice/BackofficeLogout.vue')
  },
  {
    path: '/backoffice/backoffice_statistic',
    name: 'Statistict',
    component: () => import('../views/Backoffice/BackofficeStatistic.vue')
  },
  {
    path: '/backoffice/backoffice_kinder_gardens_statistic',
    name: 'BackofficeKinderGardensStatistic',
    component: () => import('../views/Backoffice/BackofficeKinderGardensStatistic.vue')
  },
  {
    path: '/backoffice/backoffice_parents_statistic',
    name: 'BackofficeParentsStatistic',
    component: () => import('../views/Backoffice/BackofficeParentsStatistic.vue')
  },
  // {
  //   path: '/backoffice/backoffice_syatem_statistic',
  //   name: 'BackofficeParentsStatistic',
  //   component: () => import('../views/Backoffice/BackofficeSystemStatistic.vue')
  // },
  {
    path: '/backoffice/backoffice_admin_users',
    name: 'BackofficeAdminUsers',
    component: () => import('../views/Backoffice/BackofficeAdminUsers.vue')
  },
  {
    path: '/backoffice/backoffice_users',
    name: 'BackofficeUsers',
    component: () => import('../views/Backoffice/BackofficeUsers.vue')
  },
  {
    path: '/backoffice/backoffice_kinder_gardens',
    name: 'BackofficeKinderGardens',
    component: () => import('../views/Backoffice/BackofficeKinderGardens.vue')
  },
  {
    path: '/backoffice/cluster_managers',
    name: 'BackofficeClusterManagers',
    component: () => import('../views/Backoffice/BackofficeClusterManagers.vue')
  },
  {
    path: '/backoffice/cluster_manager_edit',
    name: 'BackofficeClusterManagerEdit',
    component: () => import('../views/Backoffice/BackofficeClusterManagerEdit.vue')
  },
  {
    path: '/backoffice/backoffice_add_new_parent',
    name: 'BackofficeAddParent',
    component: () => import('../views/Backoffice/BackofficeAddParent.vue')
  },
  {
    path: '/backoffice/wysiwyg',
    name: 'Wysiwyg',
    component: () => import('../views/Backoffice/BackofficeWysiwig.vue')
  },
  {
    path: '/backoffice/forgot_password',
    name: 'BackofficeForgotPassword',
    component: () => import('../views/Backoffice/BackofficeForgotPassword.vue')
  },
  {
    path: '/backoffice/backoffice_user_delete',
    name: 'BackofficeUserDelete',
    component: () => import('../views/Backoffice/BackofficeUserDelete.vue')
  },
  {
    path: '/backoffice/backoffice_parents',
    name: 'BackofficeParents',
    component: () => import('../views/Backoffice/BackofficeParents.vue')
  },
  {
    path: '/backoffice/backoffice_delete_parent',
    name: 'BackofficeDeleteParent',
    component: () => import('../views/Backoffice/BackofficeDeleteParent.vue')
  },
  {
    path: '/backoffice/backoffice_user_edit',
    name: 'BackofficeUserEdit',
    component: () => import('../views/Backoffice/BackofficeUserEdit.vue')
  },
  {
    path: '/backoffice/backoffice_edit_kindergarten',
    name: 'BackofficeEditKindergarten',
    component: () => import('../views/Backoffice/BackofficeEditKindergarten.vue')
  },
  {
    path: '/backoffice/backoffice_edit_kindergarten_location',
    name: 'BackofficeEditKindergartenLocation',
    component: () => import('../views/Backoffice/BackofficeEditKindergartenLocation.vue')
  },
  {
    path: '/backoffice/backoffice_delete_kindergarten_step_1',
    name: 'BackofficeDeleteKindergarten',
    component: () => import('../views/Backoffice/BackofficeDeleteKindergarten.vue')
  },
  {
    path: '/backoffice/backoffice_edit_location',
    name: 'BackofficeLocation',
    component: () => import('../views/Backoffice/BackofficeLocation.vue')
  },
  {
    path: '/backoffice/backoffice_user_change_password',
    name: 'BackofficeUserChangePassword',
    component: () => import('../views/Backoffice/BackofficeUserChangePassword.vue')
  },
  {
    path: '/backoffice/file_uploader',
    name: 'BackofficeFileUploader',
    component: () => import('../views/Backoffice/BackofficeFileUploader.vue')
  },
  {
    path: '/backoffice/cloudinary_file_uploader',
    name: 'BackofficeCloudinaryFileUploader',
    component: () => import('../views/Backoffice/BackofficeCloudinaryFileUploader.vue')
  },
  {
    path: '/backoffice/s3_file_uploader',
    name: 'BackofficeS3FileUploader',
    component: () => import('../views/Backoffice/BackofficeS3FileUploader.vue')
  },
  {
    path: '/backoffice/payme',
    name: 'BackofficePayme',
    component: () => import('../views/Backoffice/BackofficePayme.vue')
  },
  {
    path: '/backoffice/payme_ty',
    name: 'BackofficePaymeTy',
    component: () => import('../views/Backoffice/BackofficePaymeTy.vue')
  },
  {
    path: '/backoffice/payme_order_delete',
    name: 'BackofficePaymeOrderDelete',
    component: () => import('../views/Backoffice/BackofficePaymeOrderDelete.vue')
  },
  {
    path: '/backoffice/payme_order_refund',
    name: 'BackofficePaymeOrderRefund',
    component: () => import('../views/Backoffice/BackofficePaymeOrderRefund.vue')
  },
  {
    path: '/backoffice/payme_order_ty',
    name: 'BackofficePaymeOrderTy',
    component: () => import('../views/Backoffice/BackofficePaymeOrderTy.vue')
  },
  {
    path: '/backoffice/fixed_sms',
    name: 'BackofficeFixedSms',
    component: () => import('../views/Backoffice/BackofficeFixedSms.vue')
  },
  {
    path: '/backoffice/backoffice_add_sms',
    name: 'BackofficeAddSms',
    component: () => import('../views/Backoffice/BackofficeAddSms.vue')
  },
  {
    path: '/backoffice/backoffice_sms_delete',
    name: 'BackofficeDeleteSms',
    component: () => import('../views/Backoffice/BackofficeDeleteSms.vue')
  },


  // Leads Management Routes
  {
    path: '/backoffice/leads_cities',
    name: 'BackofficeLeadsCities',
    component: () => import('../views/Backoffice/BackofficeLeadsCities.vue')
  },
  {
    path: '/backoffice/leads_parents',
    name: 'BackofficeLeadsParents',
    component: () => import('../views/Backoffice/BackofficeLeadsParents.vue')
  },

  {
    path: '/backoffice/leads_teachers',
    name: 'BackofficeLeadsTeachers',
    component: () => import('../views/Backoffice/BackofficeLeadsTeachers.vue')
  },
  // // Public Registration (no auth)
  {
    path: '/leads/register/:uuid',
    name: 'LeadsRegistration',
    component: () => import('../views/Leads/LeadsRegistration.vue')
  },

  {
    path: '/leads/register_general',
    name: 'LeadsRegistrationGeneral',
    component: () => import('../views/Leads/LeadsRegistrationGeneral.vue')
  },
  {
    path: '/leads/register_teacher',
    name: 'LeadsTeacherRegistration',
    component: () => import('../views/Leads/LeadsTeacherRegistration.vue')
  },
  // Kindergarten Routes
  {
    path: '/kindergarten/login',
    name: 'KindergartenLogin',
    component: () => import('../views/Kindergarten/KindergartenLogin.vue')
  },
  {
    path: '/kindergarten/verify-sms',
    name: 'KindergartenVerifySms',
    component: () => import('../views/Kindergarten/KindergartenVerifySms.vue')
  },
  {
    path: '/kindergarten/home',
    name: 'KindergartenHome',
    component: () => import('../views/Kindergarten/KindergartenHome.vue')
  },
  {
    path: '/kindergarten/children',
    name: 'KindergartenChildrenList',
    component: () => import('../views/Kindergarten/KindergartenChildrenList.vue'),
  },
  {
    path: '/kindergarten/children/edit/:id',
    name: 'KindergartenChildEdit',
    component: () => import('../views/Kindergarten/KindergartenChildEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/kindergarten',
    redirect: '/kindergarten/login'
  },
  {
    path: '/kindergarten/send-message',
    name: 'KindergartenSendMessage',
    component: () => import('../views/Kindergarten/KindergartenSendMessage.vue')
  },
  {
    path: '/kindergarten/attendance-history',
    name: 'KindergartenAttendanceHistory',
    component: () => import('../views/Kindergarten/KindergartenAttendanceHistory.vue')
  },
  {
    path: '/kindergarten/profile',
    name: 'KindergartenProfile',
    component: () => import('../views/Kindergarten/KindergartenProfile.vue')
  },
  {
    path: '/',
    component: () => import('../views/Hp.vue')
  },
  {
    path: '/privacy-police',
    component: () => import('../views/PrivacyPolice.vue')
  },
  {
    path: '/accessibility',
    name: 'AccessibilityStatement',
    component: () => import('../views/Shared/AccessibilityStatement.vue')
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: () => import('../views/Shared/TermsOfUse.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/Shared/PrivacyPolicy.vue')
  },
  // Manager (cluster manager) Routes
  {
    path: '/manager/login',
    name: 'ManagerLogin',
    component: () => import('../views/Manager/ManagerLogin.vue')
  },
  {
    path: '/manager/verify-sms',
    name: 'ManagerVerifySms',
    component: () => import('../views/Manager/ManagerVerifySms.vue')
  },
  {
    path: '/manager/kindergartens',
    name: 'ManagerKindergartens',
    component: () => import('../views/Manager/ManagerKindergartens.vue')
  },
  {
    path: '/manager/daily',
    name: 'ManagerDaily',
    component: () => import('../views/Manager/ManagerDaily.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation Guard for Kindergarten routes
router.beforeEach((to, from, next) => {
  // בדיקה אם זה נתיב של Kindergarten
  const cookies = document.cookie

  if (to.path.startsWith('/kindergarten')) {
    // עמודים שלא דורשים אימות
    const publicPages = ['/kindergarten/login', '/kindergarten/verify-sms']

    // בדיקת session_id של הגננת בקוקי. גבול (^|; ) כדי לא להתבלבל עם
    // manager_session_id (שמכיל את המחרוזת "session_id=").
    const hasSessionInCookie = /(?:^|;\s*)session_id=[^;\s]/.test(cookies)

    // בדיקה אם יש session_id ב-URL (מגיע מ-Backoffice/מנהל לדף home)
    const sessionIdFromUrl = to.query.session_id
    const isBackofficeLogin = to.path === '/kindergarten/home' && sessionIdFromUrl

    if (!publicPages.includes(to.path)) {
      // עמוד מוגן - צריך session בקוקי או session_id ב-URL (רק לדף home)
      if (!hasSessionInCookie && !isBackofficeLogin) {
        return next('/kindergarten/login')
      }
    } else {
      // עמוד ציבורי (login/verify) - אם יש session בקוקי, העבר לדף הבית
      if (hasSessionInCookie) {
        return next('/kindergarten/home')
      }
    }
  }

  // Navigation Guard for Manager (cluster manager) routes
  if (to.path.startsWith('/manager')) {
    const publicManagerPages = ['/manager/login', '/manager/verify-sms']
    const hasManagerSession = /(?:^|;\s*)manager_session_id=[^;\s]/.test(cookies)

    if (!publicManagerPages.includes(to.path)) {
      if (!hasManagerSession) {
        return next('/manager/login')
      }
    } else {
      if (hasManagerSession) {
        return next('/manager/kindergartens')
      }
    }
  }

  next()
})

// <html lang/dir> נקבע לפי האזור שאליו ניווטנו: ממשק הגן/מנהל לפי השפה הנבחרת,
// וכל השאר (Backoffice, נחיתה, לידים, עמודים משפטיים) נשאר he/rtl.
// docs/features/i18n.md — "כיוון ושפת המסמך לפי אזור".
router.afterEach((to) => {
  applyDocumentDirForPath(to.path)
})

export default router
